module.exports = __webpack_public_path__ + "static/media/ic-song-priority.ecb6bd4c.svg";